import {handleActions} from "redux-actions";
import * as type from './type';

export const initialState = {
    partner: { 'active':0, 'isTreatingPhysician':0 },
    error: null,
    hasChanged: false,
    redirect:false,
    fetching: false,
    validationMessageList: []
};

export default handleActions({
    [type.EDIT_PARTNER]: (state, action) => {
        const {name, value} = action.payload
        return {
            ...state,
            hasChanged: true,
            partner: {
                ...state.partner,
                [name]: value,
            },
        }
    },
    [type.SAVE_PARTNER_REQUEST]: (state) => {
        return {
            ...state,
            fetching: true,
            error: null,
        }
    },
    [type.SAVE_PARTNER_SUCCESS]: (state) => {
        return {
            ...state,
            redirect:true
        }
    },
    [type.SAVE_PARTNER_ERROR]: (state, action) => {
        const {error} = action.payload
        return {
            ...state,
            fetching: false,
            validationMessageList: [error],
        }
    },
    [type.FIND_PARTNER_REQUEST]: (state) => {
        return {
            ...state,
            fetching: true,
        }
    },
    [type.FIND_PARTNER_SUCCESS]: (state, action) => {
        const {partner} = action.payload
        return {
            ...state,
            partner,
            hasChanged: false,
            fetching: false,
            validationMessageList: []
        }
    },
    [type.FIND_PARTNER_ERROR]: (state, action) => {
        const {error} = action.payload
        return {
            ...state,
            error,
        }
    },
    [type.VALIDATION_LIST]: (state, action) => {
        const {list} = action.payload
        return {
            ...state,
            validationMessageList: list
        }
    },
    [type.CLEAR_STATE]: () => {
        return {
            ...initialState
        }
    }
}, initialState)


// WEBPACK FOOTER //
// ./src/modules/partner/state/detail/reducer.js